const chiffreI18n = {
  "fr": {
    "chiffre": {
      "title": "Nos chiffres",
      "cards": {
        "transactions": {
          "subtitle": "transactions effectuées",
          "pill": "Depuis le lancement"
        },
        "rating": {
          "subtitle": "satisfaction client",
          "pill": "Avis internes"
        },
        "payment": {
          "subtitle": "délai moyen de paiement",
          "pill": "Virement"
        },
        "recommendation": {
          "subtitle": "nous recommandent",
          "pill": "Enquête 2024"
        }
      },
      "tooltip": {
        "illustrative": "Illustratif"
      }
    }
  },
  "en": {
    "chiffre": {
      "title": "Our numbers",
      "cards": {
        "transactions": {
          "subtitle": "transactions completed",
          "pill": "Since launch"
        },
        "rating": {
          "subtitle": "customer satisfaction",
          "pill": "Internal reviews"
        },
        "payment": {
          "subtitle": "average payment time",
          "pill": "Bank transfer"
        },
        "recommendation": {
          "subtitle": "recommend us",
          "pill": "2024 survey"
        }
      },
      "tooltip": {
        "illustrative": "Illustrative"
      }
    }
  },
  "pl": {
    "chiffre": {
      "title": "Nasze liczby",
      "cards": {
        "transactions": {
          "subtitle": "zrealizowanych transakcji",
          "pill": "Od startu"
        },
        "rating": {
          "subtitle": "satysfakcja klientów",
          "pill": "Opinie wewnętrzne"
        },
        "payment": {
          "subtitle": "średni czas płatności",
          "pill": "Przelew"
        },
        "recommendation": {
          "subtitle": "poleca nas",
          "pill": "Ankieta 2024"
        }
      },
      "tooltip": {
        "illustrative": "Ilustracyjne"
      }
    }
  },
  "es": {
    "chiffre": {
      "title": "Nuestras cifras",
      "cards": {
        "transactions": {
          "subtitle": "transacciones realizadas",
          "pill": "Desde el lanzamiento"
        },
        "rating": {
          "subtitle": "satisfacción del cliente",
          "pill": "Opiniones internas"
        },
        "payment": {
          "subtitle": "tiempo medio de pago",
          "pill": "Transferencia bancaria"
        },
        "recommendation": {
          "subtitle": "nos recomiendan",
          "pill": "Encuesta 2024"
        }
      },
      "tooltip": {
        "illustrative": "Ilustrativo"
      }
    }
  },
  "it": {
    "chiffre": {
      "title": "I nostri numeri",
      "cards": {
        "transactions": {
          "subtitle": "operazioni completate",
          "pill": "Dal lancio"
        },
        "rating": {
          "subtitle": "soddisfazione del cliente",
          "pill": "Recensioni interne"
        },
        "payment": {
          "subtitle": "tempo medio di pagamento",
          "pill": "Bonifico bancario"
        },
        "recommendation": {
          "subtitle": "consigliamo",
          "pill": "2024 sondaggio"
        }
      },
      "tooltip": {
        "illustrative": "Illustrazione"
      }
    }
  },
  "de": {
    "chiffre": {
      "title": "Unsere Zahlen",
      "cards": {
        "transactions": {
          "subtitle": "abgeschlossene Geschäfte",
          "pill": "Seit dem Start"
        },
        "rating": {
          "subtitle": "Kundenzufriedenheit",
          "pill": "Interne Überprüfungen"
        },
        "payment": {
          "subtitle": "Durchschnittliche Zahlungszeit",
          "pill": "Banküberweisung"
        },
        "recommendation": {
          "subtitle": "empfehlen uns",
          "pill": "Umfrage 2024"
        }
      },
      "tooltip": {
        "illustrative": "Illustrativ"
      }
    }
  },
  "pt": {
    "chiffre": {
      "title": "Os nossos números",
      "cards": {
        "transactions": {
          "subtitle": "transações concluídas",
          "pill": "Desde o lançamento"
        },
        "rating": {
          "subtitle": "satisfação do cliente",
          "pill": "Revisão interna"
        },
        "payment": {
          "subtitle": "tempo médio de pagamento",
          "pill": "Transferência bancária"
        },
        "recommendation": {
          "subtitle": "recomendar-nos",
          "pill": "2024 inquérito"
        }
      },
      "tooltip": {
        "illustrative": "Ilustrativo"
      }
    }
  },
  "cs": {
    "chiffre": {
      "title": "Naše čísla",
      "cards": {
        "transactions": {
          "subtitle": "dokončené transakce",
          "pill": "Od startu"
        },
        "rating": {
          "subtitle": "spokojenost zákazníků",
          "pill": "Interní přezkum"
        },
        "payment": {
          "subtitle": "průměrná doba platby",
          "pill": "Bankovní převod"
        },
        "recommendation": {
          "subtitle": "Doporučit",
          "pill": "2024 průzkum"
        }
      },
      "tooltip": {
        "illustrative": "Ilustrativní"
      }
    }
  },
  "nl": {
    "chiffre": {
      "title": "Onze nummers",
      "cards": {
        "transactions": {
          "subtitle": "voltooide transacties",
          "pill": "Sinds de lancering"
        },
        "rating": {
          "subtitle": "klanttevredenheid",
          "pill": "Interne evaluaties"
        },
        "payment": {
          "subtitle": "gemiddelde betalingstermijn",
          "pill": "Bankoverschrijving"
        },
        "recommendation": {
          "subtitle": "ons aanbevelen",
          "pill": "2024 enquête"
        }
      },
      "tooltip": {
        "illustrative": "Illustratief"
      }
    }
  }
};

export default chiffreI18n;
